import { z } from 'zod';
import { OrderSchema } from '../order/OrderSchema';
import { BookingSchema } from '../booking/BookingSchema';

export type SpotInfoDisplaySchema = {
  id: string;
  name: string;
  note: string;
  //image: string | null;
  //category: string;
  // Customer: string;
  //type: string;
  //duration: number;
  isAutoGenerated: boolean;
 statusId :number;
  isSelected: boolean;
  isDeleted: boolean;
  media: MediaDisplaySchema | null;
  error:string;
   url?: string;
   warnings:string;
   dateChanged : string | null;
    mimeType: string | null;  
     length: number | null;
  snapshotPath: string | null;
};

export type MediaDisplaySchema = {
  mediaFileId: string;
  spotId: string;
  mimeType: string | null;  
  aspectRatio: string | null;
  width: number | null;
  height: number | null;
  length: number | null;
  snapshotPath: string | null;
  fileData: string | null;
}

export type Folder =
{
  id:string,
  name: string;
  fullName: string;
  children: Folder[];
  files: string[];
}
export const MediaSchema = z.object({
  mediaFileId: z.string().uuid().optional().nullable(),
  spotId: z.string().uuid().optional().nullable(),
  customerId: z.string().uuid().optional().nullable(),
  mimeType: z.string().optional().nullable(),
  pathServer: z.string().optional().nullable(),
  formatConverted: z.string().optional().nullable(),
  aspectRatio: z.string().optional().nullable(),
  length: z.number().optional().nullable(),
  size: z.number().optional().nullable(),
  width: z.number().optional().nullable(),
  height: z.number().optional().nullable(),
  fileData: z.string().nullable().default(null),
  snapshotPath: z.string().optional().nullable(),
lastModified: z.string().optional().nullable()

})

export const SpotSchema = z.object({
  customerId: z.string().uuid().optional().nullable(),
  spotId: z.string().uuid().optional().nullable(),
  spotName: z.string(),
  statusId: z.number().default(1),
  templateId: z.string().uuid().optional().nullable(),
  //statusDescription: z.string().optional().nullable().default("Editing"),
  comment: z.string().default("").optional().nullable(),
  note: z.string().optional().nullable(),
  tbMediaFiles : z.array(MediaSchema).optional().nullable(),
  //tbBookings : z.array(BookingSchema).optional().nullable()
  hasBookings: z.boolean().default(false).nullable(),
  
})

export type SiteSetting = {
  siteId: string;
  type: string;
  aspectRatio: string;
  minWidth: number;
  maxWidth: number;
  minHeight: number;
  maxHeight: number;
  extensions: string;
};
export type SiteInfo={
  siteId: string;
  name: string;
  siteSettings: SiteSetting[];
}


export type Template = {
  templateId: string;
  template_templateId: string;
  templateName: string | null;  
  customerId: string | null;  
  numberOfPages: number | null;
  templateFormats: TemplateFormat[];
}

export type TemplateFormat = {
  templateId: string;
  templateFormatId: string;
  aspectRatio: string | null;  
  html: string | null;  
  pathServer: number | null;
  isGenerated: boolean ;
}
export const TemplateSchema = z.object({
  templateId: z.string().uuid().optional().nullable(),
  template_templateId: z.string().uuid().optional().nullable(),
  // customerId: z.string().uuid().optional().nullable(),
  templateName: z.string().optional().nullable(),
  numberOfPages: z.number(),
  html: z.string().optional().nullable(),
  isHTML: z.boolean().default(true),
  isGenerated: z.boolean().default(false)

  
})

export const TemplateFormatSchema = z.object({
  templateId: z.string().uuid().optional().nullable(),
  templateFormatId: z.string().uuid().optional().nullable(),
  aspectRatio: z.string().optional().nullable(),
  PathServer: z.string().optional().nullable(),

  
})